// extracted by mini-css-extract-plugin
export default {"wrap":"Xd5shFZElyKWggB3DOOh","content":"wnL8X4L3XZnyxLnDD1cX","aside":"CHaA96P9_T1uMkXqfHj4"};